import axios from 'axios'
import * as Util from '@/vuex/util'

let startState = []

const state = {
  neighborhoods: startState
}

const mutations = {
  FETCH (state) {
    axios.get(Util.makeApiUrl('/neighborhood/all')).then(function (response) {
      state.neighborhoods = response.data
    }).catch(function (error) {
      console.log(error)
    })
  },

  RESET (state) {
    state.neighborhoods = startState
  }
}

const actions = {
  fetch: function ({commit}, filters) {
    commit('FETCH', filters)
  },

  reset: function ({commit}) {
    commit('RESET')
  }
}

const getters = {
  get: state => state.neighborhoods
}

export const NeighborhoodsView = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/views/NeighborhoodsView.js